import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { QuickRepliesResponse } from "../schemas/quick_replies";

export const queryKeyPrefix = "getQuickReplies";
type QueryKey = [typeof queryKeyPrefix, number];
export const getQuickRepliesQueryKey = (userID: number): QueryKey => [queryKeyPrefix, userID];

export const useGetQuickReplies = (userID: number): UseQueryResult<QuickRepliesResponse, Error> => {
  const client = useApiClient();

  return useQuery({ queryKey: getQuickRepliesQueryKey(userID), queryFn: () => client.getQuickReplies(userID) });
};
